'use client';

import { useRouter } from 'next/navigation';

export const fetchInterceptor = () => {
  const router = useRouter();
  
  return async (url: string, options?: RequestInit) => {
    try {
      const response = await fetch(url, options);
      
      if (response.status === 401) {
        // Redirect to root path if unauthorized
        router.push('/');
        return null;
      }
      
      return response;
    } catch (error) {
      console.error('Fetch error:', error);
      throw error;
    }
  };
};